import { Link, useLocation } from 'react-router-dom';
import { useDynamicBreadcrumbTitle } from '@/hooks/useDynamicBreadcrumb';

interface Crumb {
  label: string;
  path?: string;
}

const staticCrumbs: Record<string, Crumb[]> = {
  '/goods': [
    { label: '物资浏览' },
  ],
  '/cart': [
    { label: '购物车' },
  ],
  '/orders': [
    { label: '我的订单' },
  ],
  '/proxy-order': [
    { label: '代购下单' },
  ],
  '/reports': [
    { label: '数据报表' },
  ],
  '/frequent-purchase': [
    { label: '常购单' },
  ],
  '/work-approval': [
    { label: '工作审批' },
  ],
  '/purchase-plan': [
    { label: '采购计划' },
  ],
  '/after-sales': [
    { label: '我的售后' },
  ],
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathname = location.pathname;
  const dynamicTitle = useDynamicBreadcrumbTitle();

  if (pathname === '/' || pathname === '/login' || pathname === '/no-permission') return null;

  const crumbs: Crumb[] = [{ label: '首页', path: '/goods' }];

  // Exact match
  if (staticCrumbs[pathname]) {
    crumbs.push(...staticCrumbs[pathname]);
  } else if (pathname.startsWith('/product/')) {
    crumbs.push(
      { label: '物资浏览', path: '/goods' },
      { label: dynamicTitle || '商品详情' },
    );
  } else if (pathname.startsWith('/order/')) {
    crumbs.push(
      { label: '我的订单', path: '/orders' },
      { label: dynamicTitle || '采购单' },
    );
  } else if (pathname.startsWith('/purchase-plan/')) {
    crumbs.push(
      { label: '采购计划', path: '/purchase-plan' },
      { label: dynamicTitle || '计划详情' },
    );
  }

  if (crumbs.length <= 1) return null;

  return (
    <div className="px-4 md:px-6 pt-4 pb-3">
      <nav className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <div key={`${crumb.label}-${index}`} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-300 text-xs" />
              )}
              {isLast ? (
                <span className="text-foreground-800 font-medium">{crumb.label}</span>
              ) : (
                <Link
                  to={crumb.path || '/goods'}
                  className="hover:text-primary-600 transition-colors"
                >
                  {index === 0 ? (
                    <span className="flex items-center gap-1">
                      <i className="ri-home-line text-xs" />
                      {crumb.label}
                    </span>
                  ) : (
                    crumb.label
                  )}
                </Link>
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
}
